'use client';

import { UserInventoryItemResponseStatusEnum } from '../../services/generated/Api';

type StatusLabelKey =
  | 'statusAvailable'
  | 'statusSold'
  | 'statusProcessing'
  | 'statusSent'
  | 'statusConfirmed'
  | 'statusContractConsumed'
  | 'statusUpgradeConsumed';

export const getStatusLabel = (
  status: UserInventoryItemResponseStatusEnum,
  t: (key: StatusLabelKey) => string,
) => {
  switch (status) {
    case UserInventoryItemResponseStatusEnum.AVAILABLE:
      return { text: t('statusAvailable'), color: '#10b981' };
    case UserInventoryItemResponseStatusEnum.SOLD:
      return { text: t('statusSold'), color: '#ef4444' };
    case UserInventoryItemResponseStatusEnum.PROCESSING:
      return { text: t('statusProcessing'), color: '#f59e0b' };
    case UserInventoryItemResponseStatusEnum.SENT:
      return { text: t('statusSent'), color: '#3b82f6' };
    case UserInventoryItemResponseStatusEnum.CONFIRMED:
      return { text: t('statusConfirmed'), color: '#10b981' };
    case UserInventoryItemResponseStatusEnum.CONTRACT_CONSUMED:
      return { text: t('statusContractConsumed'), color: '#ef4444' };
    case UserInventoryItemResponseStatusEnum.UPGRADE_CONSUMED:
      return { text: t('statusUpgradeConsumed'), color: '#ef4444' };
    default:
      return { text: status, color: '#6b7280' };
  }
};
